import * as React from "react";
import "../../../style/footer.css";
import "../../../style/App.css";
import Footer1 from "./Footer1";
import { t } from "i18n-js";
const Footer = () => {
  if (
    window.location.href.includes("inApp") ||
    window.location.href.includes("game")
  ) {
    return <div></div>;
  }
  return (
    <div className="FOOTER_CONT">
      <div className="FOOTER">
        <Footer1 />
      </div>
      <br></br>
      <a className="REG_TEXT" href="/labeling">
        {t("WARNINGS")}
      </a>
      <br />
      <br />
      <br />
      <br />
    </div>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/layout/Footer/Footer.tsx